export default __webpack_public_path__ + "static/media/feedback.6cfcda47.svg";